import { MyLeadsSearchQuery } from '@mm/state/interfaces/myLeads';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useCreateFilterParams = (defaultParams?: MyLeadsSearchQuery) => {
  const location = useLocation<MyLeadsSearchQuery>();
  const [filterParams, setFilterParams] = useState<MyLeadsSearchQuery>(
    location.state || {},
  );

  useEffect(() => {
    setFilterParams(location.state || defaultParams || {});
  }, [location.state?.query]);

  return {
    filterParams,
    setFilterParams,
  };
};
